import Request from '@/requests/Request'

const resource = "/projetos";

export default {
  findAll() {
    return Request.get(`${resource}`)
  },
  
  findById(projetoId) {
    return Request.get(`${resource}/${projetoId}`)
  },
  
  post(projeto) {
    return Request.post(`${resource}`, projeto)
  },
  
  put(id, projetoForm) {
    projetoForm.comissao = null
    projetoForm.meses = null
    projetoForm.participantes = null
    
    return Request.put(`${resource}/${id}`, projetoForm)
  },
  
  delete(projetoId) {
    return Request.delete(`${resource}/${projetoId}`)
  },
  
  addParticipante(id, participante) {
    return Request.post(`${resource}/${id}/addParticipante`, {
      usuario: {
        id: participante.usuario.id
      },
      papel: participante.papel
    })
  },

  removerParticipante(id, participanteId) {
    return Request.delete(`${resource}/${id}/removerParticipante`, { params: { participanteId } })
  },

  addOrganizacao(projetoId, organizacaoId) {
    return Request.post(`${resource}/${projetoId}/organizacao/${organizacaoId}`)
  },

  removerOrganizacao(projetoId, organizacaoId) {
    return Request.delete(`${resource}/${projetoId}/organizacao/${organizacaoId}`);
  },

  findIndicadoresByProjetoId(projetoId) {
    return Request.get(`${resource}/${projetoId}/indicadores`)
  },

}
